<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            label: String,
            value: [String, Number, Array],
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            multipleMini: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                val: 0,
                bool: false,
            }
        },
        methods: {
            change(v) {
                this.$emit('change', v);
            }
        },
        computed: {},
        watch: {
            value(v) {
                this.val = v;
            },
            val(v) {
                this.$emit('input', v);
            },
        },
        components: {},
        mounted() {
            this.val = this.value;
            this.bool = true;
        },
        destroyed() {
        },
    }
</script>
<template>
    <div class="input-certificate-type"
         :class="{'mini--multiple': multiple&&multipleMini}">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-select
                    v-model="val"
                    :disabled="disabled"
                    :clearable="clearable"
                    :collapse-tags="multiple"
                    :multiple="multiple"
                    @change="change"
                    :filterable="filterable"
            >
                <el-option :value="1" label="одноразовый"></el-option>
                <el-option :value="2" label="многоразовый"></el-option>
            </el-select>
            <i
                    v-if="multiple && multipleMini && clearable && val && val.length"
                    title="Очистить список"
                    @click="change([])"
                    class="el-select__caret el-input__icon el-icon-circle-close is-show-close"
            ></i>
        </div>
    </div>
</template>
<style lang="scss">
    .input-certificate-type {
        position: relative;
        .el-select {
            width: 100%;
        }
    }
</style>
